import { BinaryReader, BinaryWriter } from "../../../binary";
/**
 * FeeShare defines an instance that organizes fee distribution conditions for
 * the owner of a given smart contract
 */

/**
 * FeeShare defines an instance that organizes fee distribution conditions for
 * the owner of a given smart contract
 */

/**
 * FeeShare defines an instance that organizes fee distribution conditions for
 * the owner of a given smart contract
 */

function createBaseFeeShare() {
  return {
    contractAddress: "",
    deployerAddress: "",
    withdrawerAddress: ""
  };
}
export const FeeShare = {
  typeUrl: "/juno.feeshare.v1.FeeShare",
  encode(message, writer = BinaryWriter.create()) {
    if (message.contractAddress !== "") {
      writer.uint32(10).string(message.contractAddress);
    }
    if (message.deployerAddress !== "") {
      writer.uint32(18).string(message.deployerAddress);
    }
    if (message.withdrawerAddress !== "") {
      writer.uint32(26).string(message.withdrawerAddress);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeeShare();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.contractAddress = reader.string();
          break;
        case 2:
          message.deployerAddress = reader.string();
          break;
        case 3:
          message.withdrawerAddress = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$contractAddre, _object$deployerAddre, _object$withdrawerAdd;
    const message = createBaseFeeShare();
    message.contractAddress = (_object$contractAddre = object.contractAddress) !== null && _object$contractAddre !== void 0 ? _object$contractAddre : "";
    message.deployerAddress = (_object$deployerAddre = object.deployerAddress) !== null && _object$deployerAddre !== void 0 ? _object$deployerAddre : "";
    message.withdrawerAddress = (_object$withdrawerAdd = object.withdrawerAddress) !== null && _object$withdrawerAdd !== void 0 ? _object$withdrawerAdd : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseFeeShare();
    if (object.contract_address !== undefined && object.contract_address !== null) {
      message.contractAddress = object.contract_address;
    }
    if (object.deployer_address !== undefined && object.deployer_address !== null) {
      message.deployerAddress = object.deployer_address;
    }
    if (object.withdrawer_address !== undefined && object.withdrawer_address !== null) {
      message.withdrawerAddress = object.withdrawer_address;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.contract_address = message.contractAddress;
    obj.deployer_address = message.deployerAddress;
    obj.withdrawer_address = message.withdrawerAddress;
    return obj;
  },
  fromAminoMsg(object) {
    return FeeShare.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return FeeShare.decode(message.value);
  },
  toProto(message) {
    return FeeShare.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feeshare.v1.FeeShare",
      value: FeeShare.encode(message).finish()
    };
  }
};